import React from 'react';
import {
  Tier1OrderUserDecision,
  Tier1RebalanceProposal,
  Tier1TradeOrderLineStatus,
} from '../../types/tier1Portfolio';
import EtfSymbolLink from './EtfSymbolLink';
import { fmtUsd } from './format';
import { formatRegistryStatus } from './tier1PlannedAction';

interface Props {
  proposalId: string;
  orderIndex: number;
  order: Tier1RebalanceProposal['orders'][number];
  registryStatus?: string;
  tradeStatus?: Tier1TradeOrderLineStatus;
  decision: Tier1OrderUserDecision;
  onDecisionChange: (index: number, decision: Tier1OrderUserDecision) => void;
  readOnly?: boolean;
}

const Tier1TradeRow: React.FC<Props> = ({
  proposalId,
  orderIndex,
  order,
  registryStatus,
  tradeStatus,
  decision,
  onDecisionChange,
  readOnly,
}) => {
  const lineKey = `${proposalId}:${orderIndex}`;
  const sideClass =
    order.side === 'BUY'
      ? 'bg-green-100 text-green-800'
      : 'bg-red-100 text-red-800';

  return (
    <tr className="border-t border-gray-100 text-sm">
      <td className="px-2 py-2 capitalize text-gray-600">{order.sleeveKey ?? '—'}</td>
      <td className="px-2 py-2">
        <EtfSymbolLink symbol={order.symbol} sleeveKey={order.sleeveKey} />
      </td>
      <td className="px-2 py-2">
        <span className={`rounded px-1.5 py-0.5 text-xs font-medium ${sideClass}`}>
          {order.side}
        </span>
      </td>
      <td className="px-2 py-2 text-right tabular-nums">{order.quantity ?? '—'}</td>
      <td className="px-2 py-2 text-right tabular-nums">
        {order.estNotionalUsd != null ? fmtUsd(order.estNotionalUsd) : '—'}
      </td>
      <td className="px-2 py-2 text-xs text-gray-500">{formatRegistryStatus(registryStatus)}</td>
      <td className="px-2 py-2 text-xs text-gray-600">
        {tradeStatus ? (
          <>
            {tradeStatus.status}
            {tradeStatus.rejectionReason ? (
              <span className="block text-red-600">{tradeStatus.rejectionReason}</span>
            ) : null}
          </>
        ) : (
          '—'
        )}
      </td>
      {!readOnly ? (
        <td className="px-2 py-2">
          <div className="flex gap-1">
            <button
              type="button"
              title={`Approve line ${lineKey}`}
              onClick={() => onDecisionChange(orderIndex, 'approved')}
              className={`rounded px-2 py-0.5 text-xs font-medium ${
                decision === 'approved'
                  ? 'bg-green-600 text-white'
                  : 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              Approve
            </button>
            <button
              type="button"
              onClick={() => onDecisionChange(orderIndex, 'denied')}
              className={`rounded px-2 py-0.5 text-xs font-medium ${
                decision === 'denied'
                  ? 'bg-gray-700 text-white'
                  : 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              Deny
            </button>
          </div>
        </td>
      ) : (
        <td className="px-2 py-2 text-xs capitalize text-gray-500">{decision}</td>
      )}
    </tr>
  );
};

export default Tier1TradeRow;
